import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from '../../store';
import { loadProjectSettings, loadSystemTimeZone } from '../../store/project/projectSlice';
import { setTimeZones } from '../../utils/timeZone';

/**
 * 시간대를 화면 전체에 맞춘다 (화면 없음) — 앱에 하나만 둔다.
 *
 * 앱이 뜨면 시스템 기본을, 프로젝트를 고르면 그 프로젝트의 설정을 받아서 utils/timeZone 에 옮긴다.
 * 날짜 표시(formatters)와 DAG 변환 요청(withTimeZone)이 그 값을 쓴다.
 * 받지 못하면(오래된 서버 등) 한국시간으로 둔다 — 표시를 못 할 뿐 편집을 막을 일은 아니다.
 */
const TimeZoneSync: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const systemTz = useSelector((s: RootState) => s.project.systemTimeZone);
  const projectId = useSelector((s: RootState) => s.project.selectedProjectId);
  const projectTz = useSelector((s: RootState) => (projectId ? s.project.projectSettings[projectId]?.timeZone : null));

  useEffect(() => { dispatch(loadSystemTimeZone()); }, [dispatch]);
  useEffect(() => { if (projectId) dispatch(loadProjectSettings(projectId)); }, [dispatch, projectId]);
  // 렌더 중에 바로 맞춘다 — effect 로 미루면 첫 그림이 이전 시간대로 한 번 그려진다
  setTimeZones(systemTz, projectTz ?? null);
  useEffect(() => { setTimeZones(systemTz, projectTz ?? null); }, [systemTz, projectTz]);
  return null;
};

export default TimeZoneSync;
